import React, { useContext } from "react";
import "./Your_Price_Summary.css";
import Prev_Btn from "../../../../common/common-btn/prev-btn/Prev_Btn";
import Next_Btn from "../../../../common/common-btn/next-btn/Next_Btn";
import { Context } from "../../../../../utils/context";
import { formatAmount } from "../../../../../utils/common";

const Your_Price_Summary = ({ setActiveTab }) => {

  const {
    IMG_URL,
    Select2Data,
    getData,
    postData,
    BookingData,
    appSetup,
    setBookingData
  } = useContext(Context);
  const handleNext = () => {
    setActiveTab("pickup");
  };

  const handleBack = () => {
    setActiveTab("conditions");
  };

  return (
    <section className="Your_Price_Summary Your_Booking_Conditions">
      <div className="booking_card">
        <div className="row justify-content-center">
          <div className="col-lg-8">
            <h6 className="booking_headings">Price Summary</h6>
            <div className="info_row">
              <span>Taxi Booking</span>
              <span>:</span>
              <span>{formatAmount(BookingData?.sub_total)}</span>
            </div>
            <div className="info_row">
              <span>No. Of Vehicle</span>
              <span>:</span>
              <span>{BookingData?.no_of_cars || "1"}</span>
            </div>
            <div className="info_row">
              <span>GST Charges ({appSetup?.gst_percentage || "5"}%)</span>
              <span>:</span>
              <span>{formatAmount(BookingData?.gst_charges)}</span>
            </div>
            <div className="info_row">
              <span>Processing Fee</span>
              <span>:</span>
              <span>{formatAmount(BookingData?.platform_charges)}</span>
            </div>


            <div className="info_row">
              <span className="booking_headings">Total Price</span>
              <span className="booking_headings">:</span>
              <span className="booking_headings"> {formatAmount(BookingData?.fare)}</span>
            </div>
          </div>
        </div>

        <div className="oxygen_rent_div">
          <div className="row justify-content-center">
            <div className="col-lg-8">
              <h6 className="col_text">
                You will be able to modify your pick-up time later, until 5 days
                before your trip.
              </h6>

              <h6 className="col_text">
                Information about how to do the modification will be sent to you
                by email as soon as your booking is confirmed.
              </h6>
            </div>
          </div>
        </div>
      </div>

      <div className="both_btn_holder">
        <div onClick={handleBack}>
          <Prev_Btn text="Back" />
        </div>

        <div onClick={handleNext}>
          <Next_Btn text="Next" />
        </div>
      </div>
    </section>
  );
};

export default Your_Price_Summary;
